import { trackEvent } from '@opendoor/shared-fe/build/analytics';

import { SavedAnswer } from 'src/store/sellerInput';

export const trackAnswerChange = (key: string, value?: SavedAnswer) => {
  trackEvent('flow-answer', 'change', 'answer', {
    answer: value,
    question_key: key,
  });
};
